import { Box } from '@mui/material';

const getSrcFromContent = content => {
  if (!content) return '';
  const trimmed = String(content).trim();

  // already a data URL
  if (trimmed.startsWith('data:')) return trimmed;

  // raw SVG markup
  if (trimmed.startsWith('<')) {
    // encode to make it safe for data URL
    return `data:image/svg+xml;utf8,${encodeURIComponent(trimmed)}`;
  }

  // assume plain base64 (e.g. PNG/JPEG)
  return `data:image/png;base64,${trimmed}`;
};

const ImagePreview = ({ alt = 'Image', style, base64 }) => {
  const src = getSrcFromContent(base64);
  if (!src) return null;

  return <Box component="img" src={src} alt={alt} sx={{ ...style }} />;
};

export default ImagePreview;
